module.exports = "<div class=\"gw-carousel\">\r\n    <div uib-carousel slides=\"slides\" active-fn=\"activeFn\" interval=\"interval\" no-wrap=\"!wrapSlides\">\r\n        <gw-carousel-slides ng-transclude>\r\n        </gw-carousel-slides>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/carousel/directives/templates/gw-carousel.html
// module id = 567
// module chunks = 0